// Global packages and components
import { Slider, Heading, BlogListerItem } from '~/components'

// Types
import type { BlogListingItem } from '~/types'

interface BlockPostCarouselProps {
  title?: string
  items: BlogListingItem[]
}

// Main export
export default function BlockPostCarousel({
  title,
  items,
}: BlockPostCarouselProps) {
  return items && items.length !== 0 ? (
    <div className="container">
      {title && (
        <Heading
          className="mb-10 text-center"
          tag="h2"
          size="h4"
        >
          {title}
        </Heading>
      )}
      <Slider
        className="splide__pagination-inline -mx-4"
        options={{
          breakpoints: {
            768: {
              perPage: 2,
            },
            1024: {
              perPage: 3,
            },
          },
        }}
      >
        {items.map((e, i) => (
          <div
            className="px-4"
            key={i}
          >
            <BlogListerItem
              key={i}
              {...e}
              withSchema={false}
            />
          </div>
        ))}
      </Slider>
    </div>
  ) : null
}
